import { IntlShape } from 'react-intl';
import {
  getWeekDayShortString,
  isSameDate,
  formatAMPM,
  getMonthString,
  getWeekDayFullString,
} from 'common/support/dateHelper';
import { secondsToDisplayTime } from 'common/support/stringHelper';

interface MediaItem {
  duration?: number;
  seriesTitle?: string;
}

export const getLiveFeedThumbnail = (src: string): string => {
  const paramIndex = src.indexOf('?');
  let result = src;

  if (paramIndex > -1) {
    if (
      src.includes('thumb.dev.cbsi.video') ||
      src.includes('thumb.cbsi.video')
    ) {
      return `${src}&n=${Date.now()}`;
    }
    result = result.slice(0, paramIndex);
  }

  return `${result}?n=${Date.now()}`;
};

export const getClipSubtitle = (item: MediaItem): string => {
  const subtitle = [];

  if (item.duration) {
    subtitle.push(`(${secondsToDisplayTime(item.duration)})`);
  }

  if (item.seriesTitle) {
    subtitle.push(item.seriesTitle);
  }

  return subtitle.join(' ');
};

export const getDvrTime = (date: Date, now: Date = new Date()): { value: number; unit: string } | null => {
  let diff = (now.getTime() - date.getTime()) / 1000;
  let unit: string | null = null;

  if (diff > 3600 * 24) {
    diff /= 3600 * 24;
    unit = 'd';
  } else if (diff > 3600) {
    diff /= 3600;
    unit = 'h';
  } else if (diff > 60) {
    diff /= 60;
    unit = 'm';
  } else if (diff > 0) {
    unit = 's';
  }
  // @ts-ignore - diff is supposed to be a number so this is might be a bug
  return unit ? { value: parseInt(diff, 10), unit } : null;
};

export const getVodTime = (duration: number): string => {
  return secondsToDisplayTime(duration);
};

export const getStartDate = (intl: IntlShape, date: Date, now: Date = new Date()): string | null => {
  const text = [];
  try {
    if (!isSameDate(date, now)) {
      text.push(getWeekDayShortString(intl, date));
    }
    text.push(formatAMPM(intl, date));
    return text.join(' ');
  } catch {
    // no-op
  }
  return null;
};

export const getGameDate = (intl: IntlShape, date: Date, isTts: boolean = false): string | null => {
  try {
    const weekdayString = isTts
      ? getWeekDayFullString(intl, date)
      : getWeekDayShortString(intl, date);
    return `${weekdayString}, ${getMonthString(intl, date)} ${date.getDate()}`;
  } catch {
    // no-op
  }
  return null;
};

export const getSizeByLayout = (layout: number): string => {
  const map: Record<number, string> = {
    3: 'lg',
    4: 'md',
    5: 'sm',
  };
  return map[layout] || 'lg';
};
